module.exports = __webpack_public_path__ + "img/ewell_logo-grayscale.aa2daa9b.svg";